import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view03ImageOptions } from './views/exterior_view03'

class X49MK2HullTreatment extends Component {
    constructor(props) {
        super(props);
        this.handleHullTreatmentChange = this.handleHullTreatmentChange.bind(this);
    }


    handleHullTreatmentChange(newValue) {
        let configuration = this.props.configuration;
        configuration.HullTreatment = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
		let imageOptions = exterior_view03ImageOptions;

		let image = (
			<TransomConfigurator colorMultiplier={1.0} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
				[
					0.037287, -0.023002, 0, -0.00004,
					0.001406, 0.056846, 0, 0.000008,
					0, 0, 1, 0,
					180, 177, 0, 1
				]}>
				<ConfiguratorImage boat="X4_9mk2" configuration={this.props.configuration} options={imageOptions} />
			</TransomConfigurator>
		);

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Hull treatment' /></h1>

                    <p><Trans defaults='X49 Hull Treatment Text' /></p>

                    <RadioGroup label={this.props.t("Treatment options:")} options={this.props.hullTreatmentOptions} value={this.props.configuration.HullTreatment} onChange={this.handleHullTreatmentChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49MK2HullTreatment);


// WEBPACK FOOTER //
// ./src/X49MK2/X49MK2-HullTreatment.js